import { Injectable } from '@angular/core';
import { BaseService } from '../../../../../../../shared/services/base.service';
import { ConsultationUrl } from '../../../../../../../shared/urls/consultation.url';

@Injectable()
export class RecommendedDiseaseInfoService {
    constructor(private baseService: BaseService) {
    }

    getDiseases(groupId) {
        const url = ConsultationUrl.GET_RECOMMEND_DISEASE.replace('{groupConsultationId}', groupId);
        return this.baseService.getData(url, {isHistory : true});
    }
}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/consultation/waiting-room/group-template/group-template-information-popup/group-template-information/recommended-disease-info/recommended-disease-info.service.ts